module.exports = __webpack_public_path__ + "img/01_noff_close_L2.9ce3996d.svg";